import React from 'react'
import { SimpleMenu } from '../../components'
import { object } from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './RecoverPasswordPage.styl'

class RecoverPasswordPage extends React.Component {

	static propTypes = {
		location: object
	}

	state = { success: false, email: '' }

	handleEmailChange(e) {
		this.setState({ email: e.target.value })
	}

	handleSubmit(e) {
		e.preventDefault()
		const { email } = this.state

		fetch('/api/accounts/change_password', {
			method: 'POST',
			body: JSON.stringify({ username: email }),
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'same-origin'
		})
			.then(r => {
				window.location = '/login'
			})
	}

	render() {
		const { email } = this.state
		return (
			<div>
				<SimpleMenu />
				<div className={ styles.container }>
					<div className={ styles['login-container'] }>
						<div className={ styles['title-container'] }>
							<h2>Recuperar a password</h2>
							<small>Irá ser enviado para o seu email uma password temporária.</small>
						</div>
						<form onSubmit={ this.handleSubmit.bind(this) } method="POST" className={ styles['login-form'] }>
							<div className={ styles['input-info'] }>
								<input type="email" name="email" placeholder="Email" value={ email } onChange={ this.handleEmailChange.bind(this) } />
							</div>
							<input className={ styles.submit } type="submit" value="Submeter" />
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default RecoverPasswordPage



// WEBPACK FOOTER //
// ./src/client/website/pages/RecoverPasswordPage/RecoverPasswordPage.js